module.exports = __webpack_public_path__ + "static/img/video_analytic_services.917e36ad.png";